import React from 'react';
import './Page.css';

function Newsletters() {
  return (
    <div className="page">
      <div className="page-content">
        <div className="section-heading">
          <div className="accent-line" aria-hidden="true"></div>
          <h1>Newsletters</h1>
        </div>
        <p>
          Our newsletters and communications will be available here. We periodically share our thoughts on the markets, 
          our investment philosophy, and updates about YK2 Partners.
        </p>
        <p>
          Please check back for updates and subscribe to receive our newsletters directly.
        </p>
      </div>
    </div>
  );
}

export default Newsletters;
